// CSS 토큰(src/styles/tokens.css) 중 JS에서 값이 필요한 것만 옮겨둔다.
// 값을 바꿀 때는 tokens.css 와 함께 수정한다.

export const breakpoints = {
  tablet: 768,
  desktop: 1200,
} as const;

export const media = {
  mobile: `(max-width: ${breakpoints.tablet - 1}px)`,
  tablet: `(min-width: ${breakpoints.tablet}px)`,
  desktop: `(min-width: ${breakpoints.desktop}px)`,
} as const;

export const palette = {
  primary: "#6360f6",
  primaryHover: "#4f4be0",
  danger: "#d6343a",
  success: "#30a46c",
  warning: "#f5a524",
} as const;

export const fontFamily =
  '"Pretendard Variable", Pretendard, -apple-system, BlinkMacSystemFont, system-ui, "Apple SD Gothic Neo", "Noto Sans KR", "Malgun Gothic", sans-serif';
